/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/context/server.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
export class Server {
    /**
     * @param {?} server
     */
    constructor(server) {
        this.serverVersion = server.serverVersion;
        this.serverBuildTimestamp = server.serverBuildTimestamp;
        this.googleMapsApiKey = server.googleMapsApiKey;
    }
    /**
     * @return {?}
     */
    static empty() {
        return new Server({
            serverVersion: "testing",
            serverBuildTimestamp: "the-past",
            googleMapsApiKey: "abc123",
        });
    }
    /**
     * @return {?}
     */
    static fromBody() {
        /** @type {?} */
        const server = JSON.parse(document.body.dataset.server);
        return new Server(server);
    }
}
if (false) {
    /** @type {?} */
    Server.prototype.serverVersion;
    /** @type {?} */
    Server.prototype.serverBuildTimestamp;
    /** @type {?} */
    Server.prototype.googleMapsApiKey;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vdmlzaW9uaWNzL25nL3NyYy9hcHAvY29udGV4dC9zZXJ2ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFFQSxNQUFNLE9BQU8sTUFBTTs7OztJQUNqQixZQUFZLE1BQU07UUFDaEIsSUFBSSxDQUFDLGFBQWEsR0FBRyxNQUFNLENBQUMsYUFBYSxDQUFDO1FBQzFDLElBQUksQ0FBQyxvQkFBb0IsR0FBRyxNQUFNLENBQUMsb0JBQW9CLENBQUM7UUFDeEQsSUFBSSxDQUFDLGdCQUFnQixHQUFHLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQztJQUNsRCxDQUFDOzs7O0lBRU0sTUFBTSxDQUFDLEtBQUs7UUFDakIsT0FBTyxJQUFJLE1BQU0sQ0FBQztZQUNoQixhQUFhLEVBQUcsU0FBUztZQUN6QixvQkFBb0IsRUFBRyxVQUFVO1lBQ2pDLGdCQUFnQixFQUFHLFFBQVE7U0FDNUIsQ0FBQyxDQUFDO0lBQ0wsQ0FBQzs7OztJQUVNLE1BQU0sQ0FBQyxRQUFROztjQUNkLE1BQU0sR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQztRQUN2RCxPQUFPLElBQUksTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQzVCLENBQUM7Q0FLRjs7O0lBSEMsK0JBQStCOztJQUMvQixzQ0FBc0M7O0lBQ3RDLGtDQUFrQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7SW5qZWN0YWJsZX0gZnJvbSAnQGFuZ3VsYXIvY29yZSc7XG5cbmV4cG9ydCBjbGFzcyBTZXJ2ZXIge1xuICBjb25zdHJ1Y3RvcihzZXJ2ZXIpIHtcbiAgICB0aGlzLnNlcnZlclZlcnNpb24gPSBzZXJ2ZXIuc2VydmVyVmVyc2lvbjtcbiAgICB0aGlzLnNlcnZlckJ1aWxkVGltZXN0YW1wID0gc2VydmVyLnNlcnZlckJ1aWxkVGltZXN0YW1wO1xuICAgIHRoaXMuZ29vZ2xlTWFwc0FwaUtleSA9IHNlcnZlci5nb29nbGVNYXBzQXBpS2V5O1xuICB9XG5cbiAgcHVibGljIHN0YXRpYyBlbXB0eSgpOiBTZXJ2ZXIge1xuICAgIHJldHVybiBuZXcgU2VydmVyKHtcbiAgICAgIHNlcnZlclZlcnNpb24gOiBcInRlc3RpbmdcIixcbiAgICAgIHNlcnZlckJ1aWxkVGltZXN0YW1wIDogXCJ0aGUtcGFzdFwiLFxuICAgICAgZ29vZ2xlTWFwc0FwaUtleSA6IFwiYWJjMTIzXCIsXG4gICAgfSk7XG4gIH1cblxuICBwdWJsaWMgc3RhdGljIGZyb21Cb2R5KCk6IFNlcnZlciB7XG4gICAgY29uc3Qgc2VydmVyID0gSlNPTi5wYXJzZShkb2N1bWVudC5ib2R5LmRhdGFzZXQuc2VydmVyKTtcbiAgICByZXR1cm4gbmV3IFNlcnZlcihzZXJ2ZXIpO1xuICB9XG5cbiAgcmVhZG9ubHkgc2VydmVyVmVyc2lvbjogc3RyaW5nO1xuICByZWFkb25seSBzZXJ2ZXJCdWlsZFRpbWVzdGFtcDogc3RyaW5nO1xuICByZWFkb25seSBnb29nbGVNYXBzQXBpS2V5OiBzdHJpbmc7XG59XG4iXX0=